import { Node, mergeAttributes } from "@tiptap/core";
import { isComplete } from "../lib/fill_blank_shortcut_parser";

export const FillBlankNode = Node.create({
  name: "fillBlank",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      "data-blank-id": {
        default: null,
        parseHTML: (element) => element.getAttribute("data-blank-id"),
        renderHTML: (attributes) => ({
          "data-blank-id": attributes["data-blank-id"],
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: "fill-blank" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["fill-blank", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ({ node, getPos }) => {
      const dom = document.createElement("span");
      dom.classList.add("fill-blank-node");
      dom.contentEditable = "false";
      dom.dataset.blankId = node.attrs["data-blank-id"] || "";

      const updateDisplay = () => {
        const blankId = node.attrs["data-blank-id"];
        const editorEl = dom.closest("[data-controller='fill-blanks-editor']");
        const blanksField = document.querySelector(
          "[data-fill-blanks-editor-target='blanksField']",
        );
        let blanks = {};
        try {
          blanks = blanksField ? JSON.parse(blanksField.value || "{}") : {};
        } catch {
          /* ignore */
        }

        const blankData = blanks[blankId];
        const answer = blankData?.answer;
        const mode =
          editorEl?.dataset.fillBlanksEditorModeValue ||
          editorEl?.dataset.fillBlanksMode;

        dom.textContent = answer || "___";
        dom.title = "";
        dom.removeAttribute("aria-label");

        const incomplete = !isComplete(blankData, mode);
        dom.classList.toggle("fill-blank-node--incomplete", incomplete);

        if (incomplete) {
          const incompleteLabel = editorEl?.dataset.fillBlanksIncompleteLabel;
          dom.title = incompleteLabel;
          dom.setAttribute("aria-label", incompleteLabel);
          return;
        }

        if (blankData) {
          const hintLabel = editorEl?.dataset.fillBlanksHintLabel || "Hint";
          const altLabel =
            editorEl?.dataset.fillBlanksAlternativesLabel || "Alternatives";

          const parts = [];
          if (blankData.hint) parts.push(`${hintLabel}: ${blankData.hint}`);
          if (blankData.alternatives?.length)
            parts.push(`${altLabel}: ${blankData.alternatives.join(", ")}`);
          if (parts.length) dom.title = parts.join("\n");
        }
      };

      updateDisplay();

      dom.addEventListener("click", () => {
        const blankId = node.attrs["data-blank-id"];
        dom.dispatchEvent(
          new CustomEvent("fill-blank:edit", {
            bubbles: true,
            detail: {
              blankId,
              pos: typeof getPos === "function" ? getPos() : null,
            },
          }),
        );
      });

      return {
        dom,
        update(updatedNode) {
          if (updatedNode.type.name !== "fillBlank") return false;
          node = updatedNode;
          dom.dataset.blankId = node.attrs["data-blank-id"] || "";
          updateDisplay();
          return true;
        },
        destroy() {},
      };
    };
  },
});
